/**
 * Finds an object in an array of objects based on a specified property value.
 *
 * @param {string | number | object} searchTargetValue The value to search for in the array of objects.
 * @param {string} propertyToCheck The name of the property to compare with the search value. (default: 'id')
 * @param {Array<object>} objectsToSearch The array of objects to search through.
 * @returns {object | null} The matching object or null if no matching object is found.
 */
function findObjectInArray(
  searchTargetValue,
  propertyToCheck = "id",
  objectsToSearch
) {
  if (!searchTargetValue || !objectsToSearch || objectsToSearch.length === 0) {
    return null;
  }

  let foundItem;

  try {
    foundItem = objectsToSearch.find(
      (obj) => obj[propertyToCheck] == searchTargetValue
    );
  } catch {
    return null;
  }
  return foundItem;
}

function findObjectInArrayWithFormatting(
  searchTargetValue,
  propertyToCheck = "id",
  objectsToSearch
) {
  if (!searchTargetValue || !objectsToSearch || objectsToSearch.length === 0) {
    return null;
  }

  let foundItem;

  try {
    foundItem = objectsToSearch.find(
      (obj) => obj[propertyToCheck] == searchTargetValue
    );
  } catch {
    return null;
  }
  return foundItem;
}
function dateTimeFormatter(date, dateSeparator = "-", timeSeparator = ":") {
  let d = date;
  return (
    [
      d.getDate() > 9 ? d.getDate() : `0${d.getDate()}`,
      d.getMonth() + 1 > 9 ? d.getMonth() + 1 : `0${d.getMonth() + 1}`,
      d.getFullYear(),
    ].join(dateSeparator) +
    " " +
    [
      d.getHours() > 9 ? d.getHours() : `0${d.getHours()}`,
      d.getMinutes() > 9 ? d.getMinutes() : `0${d.getMinutes()}`,
      d.getSeconds() > 9 ? d.getSeconds() : `0${d.getSeconds()}`,
    ].join(timeSeparator)
  );
}

export {
  findObjectInArray,
  findObjectInArrayWithFormatting,
  dateTimeFormatter,
};
